import React from "react";

const Nutrition = () => {
  return <div>Nutrition</div>;
};

export default Nutrition;
